const PREFIX = 'zhihuiruanqi_table_cols_'

export function loadColumnVisibility(storageKey) {
  if (!storageKey) return null
  try {
    const raw = localStorage.getItem(PREFIX + storageKey)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : null
  } catch (e) {
    return null
  }
}

export function saveColumnVisibility(storageKey, visibleMap) {
  if (!storageKey || !visibleMap) return
  try {
    localStorage.setItem(PREFIX + storageKey, JSON.stringify(visibleMap))
  } catch (e) {
    /* ignore quota / private mode */
  }
}

export function resolveColumnStorageKey(route, explicitKey) {
  if (explicitKey) return explicitKey
  if (route && route.path) return route.path
  return 'default'
}
